import Vue from 'vue'
import VueRouter from 'vue-router'
import index from './components/index.vue'
import introduction from './components/introduction.vue'
import newHome from './components/newHome.vue'

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return originalPush.call(this, location).catch(err => err)
};
export const routes = [
  {
    path: '/',
    name: 'newHomeComponent',
    meta: {
      title: 'AI魔方 - 全新版本',
      description: 'AI魔方全新版本，All in One的AI综合体'
    },
    component: newHome
  },
  {
    path: '/old-home',
    name: 'indexComponent',
    meta: {
      title: 'AI魔方 - All in One的AI综合体',
      description: 'AI魔方是一款集成多种AI功能的综合工具，支持大模型部署、AI Agent、浏览器、输入法等功能'
    },
    component: index
  },
  {
    path: '/introduction',
    name: 'introduction',
    meta: {
      title: '产品介绍 - AI魔方',
      description: 'AI魔方产品详细介绍，包括功能特点、技术优势等'
    },
    component: introduction
  },
]

const router = new VueRouter({
  routes,
  mode: 'history'
})

export default router
router.beforeEach((to, from, next) => {
  // 动态设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title
  }
  // 动态设置页面描述
  if (to.meta.description) {
    const metaDesc = document.querySelector('meta[name="description"]')
    if (metaDesc) {
      metaDesc.setAttribute('content', to.meta.description)
    }
  }
  // 原有逻辑
  if (to.path.endsWith(' ')) {
    let path = to.path.trim();
    next({path: path})
  } else if (to.path.endsWith('%20')) {
    let path = to.path.substring(0, to.path.length - 3);
    next({path: path})
  } else {
    next()
  }
})
